// Passwords and reset tokens deliberately stay outside Redux and DevTools.
const post = async (path: string, body: object): Promise<void> => {
    let response: Response;
    try {
        response = await fetch(`${process.env.REACT_APP_BASE_API_URL}Auth/${path}`, {
            method: 'POST', credentials: 'include', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body),
        });
    } catch {
        throw {status: 'FETCH_ERROR'};
    }
    if (response.ok) return;
    let data: unknown;
    try {data = await response.json();} catch {data = undefined;}
    const header = response.headers.get('Retry-After')?.trim();
    const seconds = header && /^\d+$/.test(header) ? Number(header)
        : header ? Math.ceil((Date.parse(header) - Date.now()) / 1000) : NaN;
    throw {status: response.status, data, retryAfterSeconds: Number.isFinite(seconds) ? Math.max(1, seconds) : 60};
};

export const forgotPassword = (email: string) => post('ForgotPassword', {email});
export const resetPassword = (data: {userId: string; token: string; newPassword: string; confirmPassword: string}) => post('ResetPassword', data);
